export type JobOfferStage = { label: string; startDate: string; endDate: string; amount: number };

/** Mirrors the server's monthly anniversary periods for the unsaved offer preview.
 * The server revalidates the calendar and exact centavo total before saving. */
export function jobOfferSchedule(startDate: string, months: number, salary: number): JobOfferStage[] | null {
  const start = new Date(`${startDate}T00:00:00Z`), centavos = Math.round(salary * 100);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(startDate) || !Number.isFinite(start.getTime()) || start.toISOString().slice(0, 10) !== startDate
    || !Number.isSafeInteger(months) || months < 1 || !Number.isSafeInteger(centavos) || centavos <= 0 || !Number.isSafeInteger(centavos * months)) return null;
  const boundary = (offset: number) => {
    const date = new Date(start); date.setUTCDate(1); date.setUTCMonth(date.getUTCMonth() + offset);
    const last = new Date(date); last.setUTCMonth(last.getUTCMonth() + 1); last.setUTCDate(0);
    date.setUTCDate(Math.min(start.getUTCDate(), last.getUTCDate()));
    return date;
  };
  const end = boundary(months);
  if (!Number.isFinite(end.getTime()) || end.getUTCFullYear() > 9999) return null;
  return Array.from({ length: months }, (_, index) => {
    const end = boundary(index + 1); end.setUTCDate(end.getUTCDate() - 1);
    return { label: `Month ${index + 1}`, startDate: boundary(index).toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10), amount: centavos / 100 };
  });
}
